// src/components/Sidebar/hooks/useUnreadChats.js
import { useEffect, useMemo, useState } from "react";
import api from "../../../api/axios";
import { buildWsUrl } from "../../../utils/websocket";

export default function useUnreadChats({ loggedIn, activeChatId }) {
    const [unreadChatIds, setUnreadChatIds] = useState([]);

    useEffect(() => {
        if (!loggedIn) return;

        api
            .get("/api/chat/unread_chat_categories/")
            .then((r) => setUnreadChatIds(r.data.unread_category_ids ?? []))
            .catch(console.error);

        const ws = new WebSocket(buildWsUrl("/ws/chat/unread/"));
        ws.onmessage = (e) => {
            try {
                const d = JSON.parse(e.data);
                if (d.type === "chat.unread_update" && Array.isArray(d.unread_category_ids)) {
                    setUnreadChatIds(d.unread_category_ids);
                }
            } catch { }
        };

        return () => ws.close();
    }, [loggedIn]);

    const unreadOtherExists = useMemo(
        () => unreadChatIds.some((id) => id !== activeChatId),
        [unreadChatIds, activeChatId]
    );

    const unreadCount = useMemo(
        () => unreadChatIds.filter((id) => id !== activeChatId).length,
        [unreadChatIds, activeChatId]
    );

    const clearUnread = (id) => setUnreadChatIds((prev) => prev.filter((cid) => cid !== id));

    return { unreadChatIds, setUnreadChatIds, unreadOtherExists, unreadCount, clearUnread };
}
